export const ListItemNavigationField = {
  Index: 'index',
  NextUuid: 'next_uuid',
  PreviousUuid: 'previous_uuid',
  Total: 'total',
}

export const ListItemNavigationDirection = {
  Next: 'next',
  Previous: 'previous',
}

export const LIST_ITEM_NAVIGATION_DEFAULT_TOTAL = 0

export const LIST_ITEM_NAVIGATION_EMPTY = {
  index: null,
  nextUuid: null,
  previousUuid: null,
  total: LIST_ITEM_NAVIGATION_DEFAULT_TOTAL,
}
